var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeakerIcon = function SvgSpeakerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#speaker-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#speaker-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 89.62c20.553 0 37.215-16.662 37.215-37.215S80.553 15.19 60 15.19 22.785 31.852 22.785 52.405 39.447 89.62 60 89.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    d: "M60 89.24c20.344 0 36.835-16.491 36.835-36.835S80.344 15.57 60 15.57 23.165 32.06 23.165 52.405 39.656 89.24 60 89.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#speaker-icon_svg__c)",
    stroke: "#fff",
    strokeWidth: 0.8,
    d: "M69.648 39.816c.916-.503 2.01.172 2.01 1.193v22.792c0 .99-1.026 1.653-1.923 1.237l-.087-.044c-1.508-.826-5.998-3.254-8.697-4.327l-.68-.26a25 25 0 0 0-4.534-1.22l-.29-.05-.059.29-1.028 5.141a1.027 1.027 0 0 1-1.859.368 1.03 1.03 0 0 1-.167-.67l.015-.1.989-4.937.067-.338-.343-.025a47 47 0 0 0-1.084-.065V58.8l-.185-.013c-1.897-.178-3.45-1.74-3.45-3.724v-5.316c0-2.048 1.655-3.646 3.634-3.737 2.91-.136 5.48-.558 8.387-1.642l.587-.225c2.699-1.073 7.19-3.5 8.697-4.327Zm-.487 2.596c-2.054 1.1-5.275 2.77-7.452 3.635a27.6 27.6 0 0 1-5.746 1.618l-.254.042v9.398l.254.042c1.863.309 3.723.812 5.746 1.616 2.177.864 5.398 2.535 7.452 3.635l.447.24V42.173zm-15.83 5.569q-.31.024-.626.043l-.633.035c-.956.044-1.68.803-1.68 1.688v5.316c0 .885.724 1.644 1.68 1.688q.637.03 1.258.08l.329.026v-8.901z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "speaker-icon_svg__c",
    x1: 71.962,
    x2: 42.921,
    y1: 65.697,
    y2: 47.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "speaker-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "speaker-icon_svg__b",
    width: 134.671,
    height: 134.671,
    x: -7.335,
    y: -4.93,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_158_144",
    result: "shape"
  })))));
};
export default SvgSpeakerIcon;